<script setup lang="ts">
export type TocItem = {
  id: string
  text: string
  depth: number
  inline?: string
}

const props = defineProps<{
  node: TocItem
}>()
</script>

<template>
  <li class="toc-item">
    <a :href="`#${props.node.id}`" :class="`level-${node.depth}`" class="title-font">
      <Icon v-if="props.node.inline" name="fa6-solid:link" class="noprint" />
      {{ node.text }}
    </a>
  </li>
</template>

<style lang="postcss">
.toc-item {
  font-family: var(--font-stack-title);
  font-variation-settings: 'wdth' 5;
  margin-left: 0;
  line-height: 1.2;
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;

  &.highlight > a {
    color: var(--secondary);
    font-weight: 500;
  }

  .level-1 {
    font-size: 1.1em;
  }

  .level-2 {
    padding-left: 1em;
    font-size: 1.1em;
  }

  .level-3 {
    padding-left: 2em;
  }

  .level-4 {
    padding-left: 3em;
  }

  .level-5 {
    font-size: 0.9em;
    padding-left: 4em;
  }

  .level-6 {
    font-size: 0.9em;
    padding-left: 5em;
  }
}
</style>
